module.exports = __webpack_public_path__ + "img/no-image.b51a7162.png";